import {Component, computed, inject, input} from "@angular/core";
import {SimMaterialDialogService} from "@services";
import {ImageClickHandler} from "../quill-image-popup-module/OnClickModule";
import {QuillModules} from "ngx-quill";
import {DomSanitizer} from "@angular/platform-browser";
import {StyleSafeDomSanitizer} from "./style-safe-dom-sanitizer.service";

@Component({
	selector: "sim-rich-text-editor-view",
	templateUrl: "./rich-text-editor-view.component.html",
	styleUrl: "./rich-text-editor-view.component.scss",
	providers: [
		SimMaterialDialogService,
		{
			provide: DomSanitizer,
			useClass: StyleSafeDomSanitizer,
		},
	],
	standalone: false,
})
export class RichTextEditorViewComponent {
	content = input.required<string>();
	fontSize = input<"xl" | "lg" | "lg2" | "md" | "sm">("md");

	fontSizeClass = computed(() => {
		const fontSize = this.fontSize();
		switch (fontSize) {
			case "xl":
				return "fontSizeXl";
			case "lg":
				return "fontSizeLg";
			case "lg2":
				return "fontSizeLg2";
			case "md":
				return "fontSizeMd";
			case "sm":
				return "fontSizeSm";
		}
	});

	dialogService = inject(SimMaterialDialogService);

	modules: QuillModules;

	constructor() {
		this.modules = {
			toolbar: [["bold", "italic"], ["image"], ["clean"]],
			onclick: {
				image: this._imageClickHandler,
			},
		};
	}

	private _imageClickHandler: ImageClickHandler = (dataUrl: string) => {
		this.dialogService
			.openImageDialog({
				type: "url",
				mediaUrl: dataUrl,
				mediaName: "Image",
			})
			.then();
	};
}
